export const LINE_ITEM_GEO_KEYS = {
  GEO_INCLUDED: 'geo.included',
  GEO_EXCLUDED: 'geo.excluded',
  GEO_FENCE: 'geoFence',
};
